import axios from 'axios'

export default {
    addBalance(amount) {
        return axios.post('virtual-balance/add', {amount: amount})
    },

    powerUps() {
        return axios.get('power-ups')
    }
}
